import dayjs from "dayjs";

// Amounts and figures show at most 2 decimals (the default would show up to 3): 12.3456 -> 12.35, 786489 -> 786,489
const numberFormat = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

export const formatNumber = (value) => numberFormat.format(value ?? 0);

export const formatCurrency = (value) => `$${numberFormat.format(value ?? 0)}`;

const moneyFormat = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// 1234.5 -> "1,234.50" (loan calculator, ledgers)
export const formatMoney = (value) => moneyFormat.format(value ?? 0);

// a number as it may show in a list: at most 2 decimals, none added (7 -> "7", 7.5 -> "7.5", 7.456 -> "7.46");
// text that is not a number is returned as it is
export const formatUpTo2 = (value) => {
  const number = typeof value === "string" && value.trim() !== "" ? Number(value.replace(/,/g, "")) : value;
  return typeof number === "number" && Number.isFinite(number) ? numberFormat.format(number) : String(value);
};

// the same for an amount typed in a form: cut to 2 decimals while typing ("12.345" -> "12.34"); never rounds up
export const limitTo2Decimals = (text) => {
  const value = String(text ?? "");
  const dot = value.indexOf(".");
  return dot < 0 ? value : value.slice(0, dot + 3);
};

export const formatDate =(value, pattern = "DD-MM-YYYY") =>
  value ? dayjs(value).format(pattern) : "-";

// 12000 -> "12K" (chart axes)
export const formatCompact = (value) =>
  value >= 1000 ? `${value / 1000}K` : `${value}`;

export const getGreeting = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return "Good Morning";
  if (hour < 17) return "Good Afternoon";
  return "Good Evening";
};
